module.exports = __webpack_public_path__ + "media/LandingPageAssets/time-69a57ba7.png";